import { useState, useMemo } from "react";
import { filterProducts } from "../utils";

/**
 * Hook personalizado para manejar filtros de inventario
 */
export const useFilters = (products) => {
  const [filterCategory, setFilterCategory] = useState("all");
  const [search, setSearch] = useState("");
  const [selectedTechnician, setSelectedTechnician] = useState("all");
  const [lowStockOnly, setLowStockOnly] = useState(false);

  // Productos filtrados
  const filtered = useMemo(() => {
    return filterProducts(products, { search, filterCategory });
  }, [products, search, filterCategory]);

  return {
    filterCategory,
    setFilterCategory,
    search,
    setSearch,
    selectedTechnician,
    setSelectedTechnician,
    lowStockOnly,
    setLowStockOnly,
    filtered,
  };
};

